import { Controller } from "@hotwired/stimulus";

/**
 * Фильтр, выбираемый в окне: кнопка рядом со своим `<dialog>`.
 *
 * Варианты внутри — обычные ссылки с готовым адресом, поэтому контроллеру
 * остаётся только открыть и закрыть окно. Клик мимо окна закрывает его сам
 * (см. lib/dialog.js), Esc — нативно.
 */
export default class extends Controller {
  static targets = ["dialog"];

  open() {
    this.dialogTarget.showModal();
  }

  close() {
    this.dialogTarget.close();
  }
}
